import {
	Message,
	MessageBox
} from 'element-ui'
import util from '@/libs/util.js'
import router from '@/router'
import request from '@/plugin/axios'


export default {
	namespaced: true,
	actions: {
		/**
		 * @description 登录
		 * @param {Object} context
		 * @param {Object} payload username {String} 用户账号
		 * @param {Object} payload password {String} 密码
		 * @param {Object} payload route {Object} 登录成功后定向的路由对象 任何 vue-router 支持的格式
		 */
		login({
			dispatch
		}, {
			username,
			password,
			code,
			gid,
		} = {}) {
			// 创建 FormData 对象
			const formData = new FormData();
			formData.append('username', username);
			formData.append('password', password);
			// 设置请求头
			const config = {
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			};
			return new Promise((resolve, reject) => {
				// 开始请求登录接口
				request({
						url: '/token',
						method: 'post',
						params: {
							code: code,
							gid: gid
						},
						data: formData,
						...config
					}).then(async res => {
						util.cookies.set('jwt_token', res.access_token)
						util.cookies.set('name', res.username)
						// 设置 vuex 用户信息
						await dispatch('d2admin/user/set', {
							name: res.username
						}, {
							root: true
						})
						// 用户登录后从持久化数据加载一系列的设置
						await dispatch('load')
						// 结束
						resolve()
					})
					.catch(err => {
						console.log('err: ', err)
						reject(err)
					})
			})
		},



		/**
		 * @description 注销用户并返回登录页面
		 * @param {Object} context
		 * @param {Object} payload confirm {Boolean} 是否需要确认
		 */
		logout({
			commit,
			dispatch
		}, {
			confirm = false
		} = {}) {
			/**
			 * @description 注销
			 */
			async function logout() {
				// 删除cookie
				util.cookies.remove('jwt_token')
				util.cookies.remove('name')
				util.cookies.remove('fun_auth_keys')
				// 清空 vuex 用户信息
				await dispatch('d2admin/user/set', {}, {
					root: true
				})
				// 跳转路由
				router.push({
					name: 'login'
				})
			}
			// 判断是否需要确认
			if (confirm) {
				commit('d2admin/gray/set', true, {
					root: true
				})
				MessageBox.confirm('确定要注销当前用户吗', '注销用户', {
						type: 'warning'
					})
					.then(() => {
						commit('d2admin/gray/set', false, {
							root: true
						})
						logout()
					})
					.catch(() => {
						commit('d2admin/gray/set', false, {
							root: true
						})
						// Message({
						//   message: '取消注销操作'
						// })
					})
			} else {
				logout()
			}
		},
		/**
		 * @description 用户登录后从持久化数据加载一系列的设置
		 * @param {Object} context
		 */
		load({
			dispatch
		}) {
			return new Promise(async resolve => {
				// DB -> store 加载用户名
				await dispatch('d2admin/user/load', null, {
					root: true
				})

				// DB -> store 加载主题
				await dispatch('d2admin/theme/load', null, {
					root: true
				})

				// DB -> store 加载页面过渡效果设置
				await dispatch('d2admin/transition/load', null, {
					root: true
				})

				// DB -> store 持久化数据加载上次退出时的多页列表		
				await dispatch('d2admin/page/openedLoad', null, {
					root: true
				})

				// DB -> store 持久化数据加载侧边栏数据
				await dispatch('d2admin/menu/asideMenuLoad', null, {
					root: true
				})

				// DB -> store 持久化数据加载侧边栏折叠状态
				await dispatch('d2admin/menu/asideCollapseLoad', null, {
					root: true
				})

				// DB -> store 持久化数据加载全局尺寸
				await dispatch('d2admin/size/load', null, {
					root: true
				})

				// DB -> store 持久化数据加载颜色设置
				await dispatch('d2admin/color/load', null, {
					root: true
				})

				// end
				resolve()
			})
		}
	}
}
